<template>
  <div class="flex items-center justify-between border-b border-slate-200 p-4 text-xl font-bold text-slate-900 lg:px-6">
    <p class="min-w-0 flex-1">
      <slot/>
    </p>
    <div v-if="disableClosing" class="h-12 w-12"/>
    <button v-else type="button"
            class="p-2 rounded-md focus:outline-2 border border-transparent focus:border-slate-200 transition-colors focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 focus:ring-opacity-50 hover:bg-slate-100"
            aria-label="Close popup" tabindex="0"
            @click="updateOpen(false)">
      <XMarkIcon class="h-6 w-6 text-slate-500"/>
    </button>
  </div>
</template>

<script setup>
import {XMarkIcon} from "@heroicons/vue/24/solid";

const props = defineProps({disableClosing: Boolean});
const emits = defineEmits(["update:open"]);
const updateOpen = (value) => !props.disableClosing && emits("update:open", value);
</script>
